<template>
  <div class="container" @click="goPuth">
    <!-- 头部导航栏 -->
    <HeaderRegion ref="headerForm" :isShowIndex="0"></HeaderRegion>

    <div class="main-box">
      <!--    轮播图part-->
      <div id="mainPage">
        <el-carousel indicator-position="none" :interval="3000">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <img class="banner-img" :src="item.picture" alt="banner-img" @click="linkBannerDetail(item)"/>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--    最新任务-->
      <div class="new-task">
        <div class="new-task-title">
          <div class="left-title">
            最新任务
          </div>
          <div class="right-more" @click="forMoreFn">
            查看更多
          </div>
        </div>
        <div class="new-task-line">
          <div class="new-task-one" v-for="item in taskList" @click="taskDetails(item)">
            <img class="task-img" :src="baseImgUrl+item.squarePicture" alt="" />
            <div class="task-bot">
              <div class="task-title">
                {{item.name}}
              </div>
              <div class="task-time">
                <div>活动时间：</div>
                <div>
                  起 {{item.activityStartTime}}
                </div>
                <div>
                  止 {{item.activityEndTime}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  设计大咖 -->
      <div :class="[designerList.length<5?'designer-box1':'designer-box']">
        <div class="designer-title">
          <div class="designer-title-txt">
            设计大咖
          </div>
        </div>
        <div class="designer-bot" >
          <div class="designer-left" v-if="designerList.length>4">
            <img  class="designer-left-img" src="../../../static/image/designerLeft.png" alt="" @click="leftSlide"/>
          </div>
          <div class="designer-bot-center">
            <img class="designer-img" :src="item.picture" alt="" v-for="(item,index) in designerList" v-if="index>=showStartIndex" @click="goPage(item)"/>
          </div>
          <div class="designer-right" v-if="designerList.length>4">
            <img  class="designer-right-img" src="../../../static/image/designerRight.png" alt="" @click="rightSlide"/>
          </div>
        </div>
      </div>

      <!--    合作品牌-->
      <div class="coop-box" v-if="coBrandList&&coBrandList.length>0">
        <div class="coop-title">
        合作伙伴
        </div>
        <div class="coop-bot">
          <div class="coop-bot-box" v-for="(item,index) in coBrandList">
            <img :src="item.picture" alt="" @click="rightSlide"/>
          </div>
        </div>
      </div>
    </div>


    <!-- 底部展示区域 -->
    <BottomRegion ref="bottomForm"></BottomRegion>
  </div>
</template>

<script>
import HeaderRegion from "../../components/headerRegion/headerRegion"; //引入头部导航栏
import BottomRegion from "../../components/bottomRegion/bottomRegion"; //引入底部展示
import {baseImgUrl} from "../../api/config"
export default {
  name: "home",
  components: {
    HeaderRegion,
    BottomRegion,
  },
  data() {
    return {
      headerForm: 0,
      //首页banner
      bannerList:[],
      //合作品牌
      coBrandList:[],
      //设计大咖
      designerList:[],
      showStartIndex:0,
      taskList:[],
      baseImgUrl:baseImgUrl,
    };
  },
  watch:{
    // $route(to,from){
    //   console.log(to,from)
    //   if(to!=from){
    //     localStorage.setItem('visit','1')
    //     this.$router.push({path: "/login/register"})
    //   }
    // }
  },
  created() {
    this.getLatestTask();
    // sessionStorage.setItem('visit','0')  //放在app.vue
    if(localStorage.getItem('visit')==0){
      this.getVisits()  //访问量
      this.getChannel() //渠道
    }
    let returnUrl = typeof(this.$route.query.returnUrl)!='undefined'?this.$route.query.returnUrl:"";
    sessionStorage.setItem('returnUrl',returnUrl)
  },
  methods: {
    goPuth(){  //游客模式跳转到认证页面
      console.log("跳转到登录",this.$route.query.share)
      if(this.$route.query.share || this.$route.query.returnUrl){
        this.$router.push({path: "/login/register"})
      }else{

      }
    },
    async getVisits(){  //访问量
       // console.log(3333333)
      const res = await this.$http.getVisits(2)

    },
    async getChannel(){  //渠道
      // console.log(4444)
      if(window.location.href.indexOf('?')!=-1){
        let ref = window.location.href.split('?')[1]
        if(ref.indexOf('channelId')!=-1){
          let id = ref.split('=')[1]
          sessionStorage.setItem('channelId',id)
          console.log(ref,id)
          if(id!=null){
            const res2 = await this.$http.getChannel(id)
            if(res2.code==200){
              localStorage.setItem('visit','1')
            }
          }
        }
      }
    },
    goPage(item){  //设计大咖跳转
     if(item.linkType==1&&item.izJump==1){
       //任务列表
       // item.id
       this.$router.push({
         path: "/home/bannerTaskList",
         query:{
           id:item.id
         }
       });

     }else if(item.linkType==2&&item.izJump==1){
       //任务详情
       this.$router.push({
         path: "/task/taskDetail",
         query:{
           id:item.linkContent
         }
       });
       // wx.navigateTo({
       //   url: `/pages/Taskdetails/Taskdetails?id=${item.id}&pageType=indexBanner`,
       // })
     }else if(item.linkType==3&&item.izJump==1){
       //文章详情
       this.$router.push({
         path: "/home/richText",
         query:{
           pageType:"indexBanner",
           id:item.id
         }
       });
     }
    },
    forMoreFn(){
        //任务详情
      this.$router.push({
        path: "/task/task"
      });
    },
    taskDetails(item){
      //任务详情
      this.$router.push({
        path: "/task/taskDetail",
        query:{
          id:item.id
        }
      });
    },
    async getLatestTask(){
      try {
        let data = {

        }
        const res = await this.$http.getLatestTask(data)
        if (res.code == 200) {
          this.taskList = res.result;
          this.getBanner(1);
          this.getBanner(3);
          this.getBanner(4);
        }else{
          this.$message(res.message);
        }
      } catch (e) {

        throw e
      }
    },
    linkBannerDetail(item){
      console.log(item)
      if(item.linkType==1&&item.izJump==1){
        //任务列表
        // item.id
        this.$router.push({
          path: "/home/bannerTaskList",
          query:{
            id:item.id
          }
        });

      }else if(item.linkType==2&&item.izJump==1){
        //任务详情
        this.$router.push({
          path: "/task/taskDetail",
          query:{
            id:item.linkContent
          }
        });
        // wx.navigateTo({
        //   url: `/pages/Taskdetails/Taskdetails?id=${item.id}&pageType=indexBanner`,
        // })
      }else if(item.linkType==3&&item.izJump==1){
        //文章详情
        this.$router.push({
          path: "/home/richText",
          query:{
            pageType:"indexBanner",
            id:item.id
          }
        });
      }
    },
    leftSlide(){
      if(this.showStartIndex>0){
        this.showStartIndex--;
      }
    },
    rightSlide(){
      if(this.showStartIndex<this.designerList.length-4){
        this.showStartIndex++;
      }
    },
    async getBanner(classify) {
      try {
        let data = {
          classify: classify,
        }
        const res = await this.$http.indexBanner(data)
        // console.log(res);
        if (res.code == 200) {
          let list = res.result;
          list.forEach((item, index) => {
            list[index].picture = `${baseImgUrl}${item.picture}`
          })
          if (classify == 1) {
            //首页banner
            this.bannerList = list;
          } else if (classify == 3) {
            //合作品牌
            this.coBrandList=list;
          } else if (classify == 4) {
            //设计大咖
            this.designerList=list;
          }
        }else{
          // this.$message(res.message);
          // console.log(this.$message(res.message))
        }
      } catch (e) {

        throw e
      }
    },
  },
};
</script>


<style scoped>
.container {
  width: 100%;
}
.main-box{
  padding-bottom: 128px;
}
.el-carousel{
  width: 1186px;
  height: 447px;
  margin: 10px auto 0;
}
.el-carousel /deep/ .el-carousel__container{
  width: 1186px;
  height: 447px;
}
.banner-img{
  width: 100%;
  height: 100%;
}
.new-task{
  width: 1186px;
  margin: 30px auto 0;
}
.new-task-title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.left-title{
  width: 131px;
  height: 51px;
  line-height: 51px;
  background: #E5E5E5;
  border-radius: 26px;
  text-align: center;
  font-size: 18px;
  color: #3A3A3A;
  font-weight: bold;
}
.right-more{
  font-size: 14px;
  color: #3A3A3A;
  margin-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.right-more::after{
  content: '';
  position: absolute;
  right: 0;
  width: 7px;
  height: 7px;
  border-top: 1px solid #3A3A3A;
  border-right: 1px solid #3A3A3A;
  transform: rotate(45deg);
}
.new-task-line{
  display: flex;
  /*justify-content: space-between;*/
  margin-top: 21px;
}
.new-task-one{
  width: 220px;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 21px;
}
.task-img{
  width: 220px;
  height: 220px;
}
.task-bot{
  padding: 15px 8px;
  box-sizing:border-box;
}
.task-title{
  display: inline-block;
  white-space: nowrap;
  width: 100%;
  color: #3A3A3A;
  overflow: hidden;
  text-overflow:ellipsis;
  font-size: 14px;
  font-weight: bold;
}
.task-time{
  color: #9E9E9E;
  font-size: 12px;
  margin-top: 10px;
}
.designer-box1{
  width: 1186px;
  margin: 32px auto 0;
}
.designer-box{
  width: 1330px;
  margin: 32px auto 0;
}
.designer-title{
  width: 1186px;
  margin: 0 auto;
}
.designer-title-txt{
  width: 131px;
  height: 51px;
  line-height: 51px;
  background: #E5E5E5;
  border-radius: 26px;
  text-align: center;
  font-size: 18px;
  color: #3A3A3A;
  font-weight: bold;
}
.designer-bot{
  display: flex;
  align-items: center;
  margin-top: 21px;
}
.designer-left{
  width: 49px;
  height: 49px;
  margin-right: 23px;
}
.designer-left-img{
  width: 49px;
  height: 49px;
  cursor: pointer;
}
.designer-right{
  width: 49px;
  height: 49px;
  margin-left: 23px;
}
.designer-right-img{
  width: 49px;
  height: 49px;
  cursor: pointer;
}
.designer-bot-center{
  width: 1186px;
  display: flex;
  overflow: hidden;
}
.designer-img{
  height: 269px;
  width: 269px;
  flex-shrink: 0;
  margin-right: 36px;
}
.coop-box{
  width: 1186px;
  margin: 41px auto 0;
}
.coop-title{
  display: inline-block;
  padding: 0 28px;
  /*width: 131px;*/
  height: 51px;
  line-height: 51px;
  background: #E5E5E5;
  border-radius: 26px;
  text-align: center;
  font-size: 18px;
  color: #3A3A3A;
  font-weight: bold;
}
.coop-bot{
  margin-top: 24px;
  width: 1200px;
  display:flex;
  justify-content:flex-start;
  flex-wrap:wrap;
}
.coop-bot-box {
  box-sizing: border-box;
  width: 20%;
  height: auto;
  padding: 10px;
}
.coop-bot-box img {
  width: 100%;
}
/**
.coop-bot:after{
  content: '';
  width: 700px;

}
.coop-img{
  width: 200px;
  margin-top:20px;
  height: auto;
}**/

</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue